// In PackageOverlay.js
import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import './PackageOverlay.css';

const PackageOverlay = ({ 
  packages, 
  eventName, 
  providerName, 
  onAddPackageToCart,  // Changed from onSelectPackage
  selectedPackageId,
  alreadyAdded,  // Add this prop
  eventID,  // Add this prop
  providerid  // Add this prop
}) => {
  const [visible, setVisible] = useState(false);
  const [localSelected, setLocalSelected] = useState(selectedPackageId);

  const handleSelect = (packageId) => {
    setLocalSelected(packageId);
  };

  const handleAddToCart = () => {
    const selectedPackage = packages.find(pkg => pkg.packageId === localSelected);
    
    if (!selectedPackage) return;
    
    // Call the parent function to add to cart
    onAddPackageToCart({
      packageId: localSelected,
      packageData: selectedPackage
    });
    
    setVisible(false);
    setLocalSelected(null); // Clear selection after adding
  };

  const handleClose = () => {
    setLocalSelected(selectedPackageId);
    setVisible(false);
  };

  const isPackageForEvent = (pkg) => {
    if (!pkg.recommendedEvents || pkg.recommendedEvents.length === 0) {
      return true;
    }
    return pkg.recommendedEvents.some(event => 
      event.eventName?.toLowerCase() === eventName?.toLowerCase() ||
      event.eventTitle?.toLowerCase() === eventName?.toLowerCase()
    );
  };

  const filteredPackages = packages.filter(isPackageForEvent);

  if (!packages || packages.length === 0) {
    return null;
  }

  return (
    <>
      <Button 
        label="View Packages" 
        icon="pi pi-box" 
        className="p-button-text p-button-sm"
        onClick={() => setVisible(true)}
        style={{ marginLeft: '8px' }}
      />
      
      <Dialog
        header={`Available Packages - ${providerName}`}
        visible={visible}
        style={{ width: '70vw', maxWidth: '800px' }}
        onHide={handleClose}
        footer={
          <div>
            <Button 
              label="Cancel" 
              icon="pi pi-times" 
              className="p-button-text" 
              onClick={handleClose} 
            />
            <Button 
              label={alreadyAdded ? "Replace in Cart" : "Add to Cart"}  // Dynamic label
              icon="pi pi-shopping-cart" 
              onClick={handleAddToCart}
              disabled={!localSelected}
            />
          </div>
        }
      >
        <div className="package-overlay-container">
          {filteredPackages.length === 0 ? (
            <div className="no-package-message">
              <p>No packages available for {eventName} event.</p>
              <p className="text-sm">This priest has packages, but none are recommended for your selected event.</p>
            </div>
          ) : (
            <div className="package-grid">
              {filteredPackages.map((pkg) => {
                const isSelected = localSelected === pkg.packageId;
                const hasDiscount = pkg.offeredPrice < pkg.price;
                const discountPercentage = hasDiscount 
                  ? Math.round(((pkg.price - pkg.offeredPrice) / pkg.price) * 100)
                  : 0;

                return (
                  <div 
                    key={pkg.packageId}
                    className={`package-card ${isSelected ? 'selected' : ''}`}
                    onClick={() => handleSelect(pkg.packageId)}
                  >
                    <div className="package-header">
                      <h4>{pkg.packageName}</h4>
                      {hasDiscount && (
                        <span className="discount-badge">Save {discountPercentage}%</span>
                      )}
                    </div>
                    
                    <div className="package-description">
                      <p>{pkg.description}</p>
                    </div>
                    
                    <div className="package-details">
                      <div className="detail-item">
                        <span className="detail-label">Priests Included:</span>
                        <span className="detail-value">{pkg.numberOfPriests}</span>
                      </div>
                      
                      {pkg.recommendedEvents && pkg.recommendedEvents.length > 0 && (
                        <div className="detail-item">
                          <span className="detail-label">Recommended For:</span>
                          <span className="detail-value">
                            {pkg.recommendedEvents.slice(0, 2).map(e => e.eventName || e.eventTitle).join(', ')}
                            {pkg.recommendedEvents.length > 2 && '...'}
                          </span>
                        </div>
                      )}
                      
                      <div className="detail-item">
                        <span className="detail-label">Valid Till:</span>
                        <span className="detail-value">
                          {new Date(pkg.validTill).toLocaleDateString('en-IN', {
                            day: 'numeric',
                            month: 'short',
                            year: 'numeric'
                          })}
                        </span>
                      </div>
                    </div>
                    
                    <div className="package-pricing">
                      {hasDiscount ? (
                        <>
                          <span className="original-price">₹{pkg.price}</span>
                          <span className="offered-price">₹{pkg.offeredPrice}</span>
                        </>
                      ) : (
                        <span className="offered-price">₹{pkg.price}</span>
                      )}
                    </div>
                    
                    <div className="package-status">
                      {isSelected ? (
                        <span className="selected-indicator">
                          <i className="pi pi-check-circle"></i> Selected for cart
                        </span>
                      ) : (
                        <span className="select-indicator">Click to select for cart</span>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          
          {filteredPackages.length > 0 && (
            <div className="package-selection-info">
              <p className="text-sm">
                <i className="pi pi-info-circle"></i>
                {alreadyAdded 
                  ? "This will replace the existing priest in your cart"
                  : "Package will be added directly to your cart"}
              </p>
            </div>
          )}
        </div>
      </Dialog>
    </>
  );
};

export default PackageOverlay;